import classnames from 'classnames';
import { IconProps } from '../types';

/**
 * The Wero acceptance mark, from Shopify's MIT-licensed payment_icons pack
 * (activemerchant/payment_icons). Kept as the scheme ships it, frame included.
 */
export default function WeroIcon(props: IconProps) {
  const { className, style } = props;

  return (
    <svg className={classnames('h-5', className)} viewBox="0 0 38 24" style={style} role="img" aria-label="Wero">
      <path
        opacity=".07"
        d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"
        fill="#000"
      />
      <path
        d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32z"
        fill="#fff48d"
        fillOpacity="1"
      />
      <path
        d="M55.68 41.19h8.47c4.04 0 6.64 3.02 6.64 6.57 0 2.39-1.21 4.57-3.23 5.7l3.53 5.37h-6.18l-3-4.52h-.98v4.52h-5.25zm9.75 6.59c0-1.36-.9-2.5-2.32-2.5h-2.19v4.99h2.17c1.4 0 2.34-1.13 2.34-2.49z"
        transform="translate(-.764 -7.758) scale(.39526)"
        strokeWidth="2.53"
        fill="#1d1c1c"
      />
      <path
        d="M71.26 50.02c0-4.87 3.5-9.31 9.56-9.31 6.06 0 9.6 4.44 9.6 9.31s-3.5 9.31-9.6 9.31-9.56-4.44-9.56-9.31zm13.83 0c0-2.35-1.56-4.52-4.26-4.52-2.7 0-4.26 2.17-4.26 4.52 0 2.35 1.58 4.52 4.26 4.52 2.69 0 4.26-2.18 4.26-4.52z"
        transform="translate(-.764 -7.758) scale(.39526)"
        strokeWidth="2.53"
        fill="#1d1c1c"
      />
      <path
        d="M23.42 49.2l-2.95 9.58h-4.54L9.58 41.17h5.53l3.12 10.52 3.1-10.52h4.17l3.07 10.52 3.14-10.52h5.53L30.9 58.79h-4.58l-2.91-9.6z"
        transform="translate(-.764 -7.758) scale(.39526)"
        strokeWidth="2.53"
        fill="#1d1c1c"
      />
      <path
        d="M54.6 51.85c.11-.61.17-1.24.17-1.87 0-4.87-3.5-9.31-9.6-9.31-5 0-8.26 3.02-9.24 6.82h5.65c.71-1.19 1.94-2.03 3.6-2.03 1.96 0 3.31 1.14 3.91 2.65h-13.3c-.11.61-.17 1.24-.17 1.87 0 4.87 3.5 9.31 9.57 9.31.21 0 .41 0 .61-.01 1.23-.06 2.35-.31 3.34-.71.99-.4 1.87-.95 2.61-1.61.74-.67 1.36-1.44 1.83-2.3.38-.68.67-1.42.87-2.19h-5.66c-.07.12-.15.24-.22.36-.21.28-.45.54-.73.77-.27.22-.58.41-.93.56-.35.15-.72.25-1.11.3-.2.02-.4.04-.61.04-1.93 0-3.29-1.14-3.9-2.65h13.3z"
        transform="translate(-.764 -7.758) scale(.39526)"
        strokeWidth="2.53"
        fill="#1d1c1c"
      />
      <defs>
        <clipPath id="pi-wero-clip">
          <path fill="#fff" d="M0 0h38v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
